<section>
    <div class="container">
        <div class="login-section card mx-auto p-5">

          <img src="/assets/Bergh-Bouwgroep-logo.png" alt="Bergh Bouwgroep Logo">

          <h1>Verzoek tot verwijdering van uw account</h1>
          <br><label>U kunt een verzoek tot permanente verwijdering van uw account en persoonlijke informatie indienen als u uw account wilt verwijderen van de Bergh Brandveiligheid app, neem dan contact op met ons ondersteuningsteam.</label>
          <br><label>E-mail: info&#64;berghbrandveiligheid.nl</label>
          <br><label>Telefoon: (0165) 51 55 55</label>
          <br><label>U kunt ook het <a href="https://www.berghbrandveiligheid.nl/contact">contact formulier</a> invullen.</label>
        </div>
    </div>
</section>
